import clsx from "clsx"
import "./style.scss"
import type { PropsWithChildren } from "react"
import { useGlobal } from "@/app/store/global.ts"
import { Sidebar } from "@/features/sidebar/ui"
import { useMediaQuery } from "@/shared/hooks/use-media-query.ts"
import { TopMenu } from "./top-menu.tsx"

export const Layout = ({ children }: PropsWithChildren) => {
  const isLaptop = useMediaQuery("(max-width: 1200px)")
  const isOpened = useGlobal(state => (isLaptop ? false : state.sidebarIsOpened))

  return (
    <div className="layout-container">
      <Sidebar isMobile={!!isLaptop} isOpened={isOpened} />
      <div
        className={clsx("flex h-full w-full flex-col duration-75", !isOpened && !isLaptop && "ml-14")}
        style={!isLaptop ? (isOpened ? { maxWidth: "calc(100% - 319px)" } : { maxWidth: "calc(100% - 56px)" }) : {}}
      >
        <TopMenu />
        <div className="max-h-full flex-[1_1_0] overflow-hidden bg-background">{children}</div>
      </div>
    </div>
  )
}
